const PLUGIN_NAME = 'pp-content';
const TRANSLATION_NAMESPACE = PLUGIN_NAME;

export { PLUGIN_NAME, TRANSLATION_NAMESPACE };
